var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPersonBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 26.125C33.7467 26.125 38 21.8717 38 16.625C38 11.3783 33.7467 7.125 28.5 7.125C23.2533 7.125 19 11.3783 19 16.625C19 21.8717 23.2533 26.125 28.5 26.125Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 49.875V45.125C14.25 42.6054 15.2509 40.1891 17.0325 38.4075C18.8141 36.6259 21.2304 35.625 23.75 35.625H33.25C35.7696 35.625 38.1859 36.6259 39.9675 38.4075C41.7491 40.1891 42.75 42.6054 42.75 45.125V49.875",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonBlue);
export default __webpack_public_path__ + "static/media/Icon_Person_Blue.ed977dd45a2b7199d4667bf80bfd2367.svg";
export { ForwardRef as ReactComponent };